<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="show_add"> 新增 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table :data-source="lis" bordered :pagination="false" :scroll="{ y: scroll_y }">
        <a-table-column key="title" width="30%" title="板块" data-index="title" />
        <a-table-column key="list" title="条目">
          <template slot-scope="text, record">
            <div class="answer" v-for="(item, index) in record.list" :key="index">
              <div class="item_row">
                <span>问：</span>
                <div class="item_v">{{ item.question }}</div>
              </div>
              <div class="item_row">
                <span>答：</span>
                <div class="item_v" v-html="item.answer"></div>
              </div>
            </div>
          </template>
        </a-table-column>
        <a-table-column title="操作" width="150px" key="action">
          <template slot-scope="text, record">
            <a-button size="small" type="primary" @click="edit(record)"> 编辑 </a-button>
            <a-button size="small" type="danger" @click="del(record)"> 删除 </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- 新增编辑 -->
    <a-modal :title="is" width="50%" :visible="is_show" @ok="handleOk" @cancel="cancelVisible">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
          保存
        </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="info" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="name" label="问" prop="name">
          <a-input v-model="info.name" placeholder="所属板块" />
        </a-form-model-item>
        <!-- elements -->
        <a-card
          :title="'第' + (index + 1) + '条问答'"
          style="width: 100%"
          v-for="(item, index) in info.elements"
          :key="index"
        >
          <a-icon
            @click="close_element(item,index)"
            v-if="info.elements.length > 1"
            class="extra_close"
            style="cursor: pointer; font-size: 16px; color: red"
            slot="extra"
            type="close"
          />
          <a-form-model-item
            ref="question"
            label="问"
            :prop="'elements.' + index + '.question'"
            :rules="{
              required: true,
              message: '请输入问题',
              trigger: 'blur',
            }"
          >
            <a-textarea v-model="item.question" placeholder="请输入问题描述" :auto-size="{ minRows: 2, maxRows: 6 }" />
          </a-form-model-item>
          <a-form-model-item
            ref="answer"
            label="答"
            :prop="'elements.' + index + '.answer'"
            :rules="{
              required: true,
              message: '请输入回答',
              trigger: 'blur',
            }"
          >
            <div
              class="contenteditable_cls"
              ref="HTmlInner"
              @input="contenteditable_input($event, index)"
              contenteditable="true"
            ></div>
            <!-- <a-textarea v-model="item.answer" placeholder="请输入问题回答" :auto-size="{ minRows: 2, maxRows: 8 }" /> -->
          </a-form-model-item>
        </a-card>
        <a-row
          ><a-icon
            title="增加一条"
            @click="new_add_element"
            type="plus"
            style="font-size: 24px; float: right; margin-top: 15px; cursor: pointer; color: #1890ff"
        /></a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { faq_get_list, faq_add, faq_update, faq_del , get_list_faq , addFag , editFag ,deleteFag} from '@/api/system'
export default {
  data() {
    return {
      dataList: [],
      lis: [],
      scroll_y: 150,
      is_show: false,
      is: '',
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      rules: {
        name: [{ required: true, message: '请输入所属板块', trigger: 'blur' }],
      },
      id: '',
      info: {
        name: '',
        _id: undefined,
        elements: [
          {
            question: '',
            answer: '',
          },
        ],
      },
    }
  },
  mounted() {
    this.get_lis()
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()
        console.log(this.scroll_y)
      }, 1000)
    })
  },
  methods: {
    cancelVisible() {
      this.is_show = false,
      this.dataList = []
    },
    //获取列表
    get_lis() {
      this.lis = []
      // faq_get_list
      get_list_faq().then((res) => {
        //  = res.data[0]
          this.lis.push(res.data[0])
          this.id = res.data[0].id
          
        console.log(this.lis, 'this.lis=======================')
      })
    },
    //弹出框
    show_add() {
      this.is = '新增'
      this.info = {
        _id: undefined,
        elements: [
          {
            question: '',
            answer: '',
          },
        ],
        name: '',
      }
      this.is_show = true
      $('.contenteditable_cls').html('')
    },
    //新增一条问答
    new_add_element() {
      this.info.elements.push({
        question: '',
        answer: '',
      })
    },
    //删除一条问答
    close_element(item,idx) {
      console.log(item, 'item======================')
      this.dataList.push(item.id)
      this.info.elements.splice(idx, 1)
    },
    //监听输入
    contenteditable_input(e, idx) {
      let txt = e.target.innerText
      this.info.elements[idx].answer = txt
    },
    //取消新增
    handleCancel() {
      this.is_show = false
    },
    //点击编辑
    edit(row) {
      var data = JSON.parse(JSON.stringify(row))
      this.info = {
        // _id: row._id,
        elements: data.list,
        name: data.title,
      }

      this.is = '修改'
      this.is_show = true
      setTimeout(() => {
        data.list.forEach((item, idx) => {
          $('.contenteditable_cls').eq(idx).html(item.answer)
        })
      }, 100)
    },
    // 提交
    handleOk() {
      var _this = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.is == '新增') {
            // faq_add
            //{
            //   title:
            // answer
            // question
            // }
            console.log(this.info, 'this.info==========================')
            var list = {
              id: this.id,
              title: this.info.name,
              list: this.info.elements

            }

            addFag(list).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('保存成功')
              this.handleCancel()
              this.get_lis()
            })
          } else {
            // let id=this.info._id
            // delete this.info._id
            // faq_update
             var data = {
              id: this.id,
              title: this.info.name,
              list: this.info.elements,
               deleteId: this.dataList

            }
            console.log(data,'1111111111111111111111111111111111111111111')

            editFag(data).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                 this.dataList = []
                return
              }
              this.$message.success('保存成功')
               this.dataList = []
              this.handleCancel()
              this.get_lis()
            })
          }
          $('.contenteditable_cls').html('')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //删除
    del(row) {
      console.log(row, 'row===========================')
      var _this = this
      this.$confirm({
        title: '确认删除此记录吗?',
        onOk() {
          // faq_del
          deleteFag({
            id: row.id,
          }).then((res) => {
            if (res.code != 200) {
              _this.$message.error(res.msg)
              return
            }
            _this.$message.success('删除成功')
            _this.get_lis()
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.extra_close {
  cursor: pointer;
  font-size: 16px;
  color: red;
}
.contenteditable_cls {
  width: 100%;
  min-height: 80px;
  border: 1px solid #ddd;
  outline: none;
  padding: 4px 5px;
  box-sizing: border-box;
  line-height: 21px;
  font-size: 14px;
  &:empty:before {
    content: '请输入...';
    color: rgb(189, 189, 189);
  }
  &:focus:before {
    content: none;
  }
}
.answer {
  width: 100%;
  float: left;
  .item_row {
    width: 100%;
    float: left;
    span {
      display: inline-block;
      width: 30px;
      float: left;
    }
    .item_v {
      width: calc(100% - 30px);
      float: left;
    }
  }
}
</style>
